export const PEOPLE_PAGES_FEATURE = 'people_pages'
export const PEOPLE_PAGES_PERMISSION = 'people-ui-pages'
/** Lead alerts are on every plan; People pages (profiles, the feed) stay on Pro. */
export const LEAD_ALERTS_PERMISSION = 'lead-alerts'

export const isPeoplePagesQueryEnabled = (canViewPeoplePages: boolean | undefined): boolean | undefined =>
  canViewPeoplePages

export const isPeopleIntegrationQueryEnabled = (
  canViewPeoplePages: boolean | undefined,
  isIdentifiedVisitor: boolean,
  hasIntegratedPartner: boolean
): boolean | undefined => canViewPeoplePages && isIdentifiedVisitor && hasIntegratedPartner
